module.exports = __webpack_public_path__ + "static/img/news19_7.57b6364.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news19_7.jpeg
// module id = Dz75
// module chunks = 0